import React from 'react'
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
} from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { addCommas } from '../../utils/functions/commas';
import { Unstable_DateField as DateField } from '@mui/x-date-pickers/DateField';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { swalErrorBtn, swalLoading, swalSuccessBtn } from '../../helpers/swalHelper';
import InvoiceListApi from '../../service/invoice.api';
import 'dayjs/locale/th';

const ariaLabel = { 'aria-label': 'description' };

function TableUploadUtan({ allowEdit, showData, statusETax }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const total = showData?.length || 0;
    // customFile = false;

    const [isSending, setIsSending] = useState(false);

    const schema = () => {
        const baseSchema = {
          rows: yup.array().of(
            yup.object().shape({
              email: yup
                .string()
                .nullable()
                .test(
                  'is-valid-email-list',
                  'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง (สามารถกรอกหลายอีเมลได้โดยใช้จุลภาคคั่น)',
                  (value) => {
                    // If etaxStatus is true, email is required
                    if (statusETax && !value) {
                      return false; // Email is required when etaxStatus is true
                    }
    
                    if (value) {
                      const emails = value.split(',').map((email) => email.trim());
                      const emailRegex =
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                      return emails.every((email) => emailRegex.test(email));
                    }
    
                    return true; // If no email is provided, it's valid when etaxStatus is false
                  },
                ),
            }),
          ),
        };
    
        return yup.object().shape(baseSchema);
      };
    
      const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        trigger,
        control,
      } = useForm({
        resolver: yupResolver(schema()),
      });
    
      const { fields, append, remove } = useFieldArray({
        control,
        name: 'rows',
      });
    
      const onSubmit = async (item) => {
        // console.log('item', item);
    
        if (isSending) return;
        setIsSending(true);
    
        swalLoading({title: 'กำลังอัปโหลดข้อมูล...'});
    
        try {
          const updatedData = item.rows.map((row) => ({
            ...row,
          }));
    
          const data = await InvoiceListApi.uploadInvoiceApi(updatedData);
          
          if (data.status_message === 'create success') {
            // setOpenDialog(true);
            swalSuccessBtn({
              title: 'อัปโหลดข้อมูลสำเร็จ'
            }).then((result) => {
              window.location.reload();
            });
          }
        } catch (error) {
          console.log(error);
          swalErrorBtn({title: 'อัปโหลดข้อมูลไม่สำเร็จ'});
        } finally {
          setIsSending(false);
        }
      };
    
      const cancel = () => {
        swalErrorBtn({
          title: 'ยกเลิกการอัปโหลดข้อมูล', 
          icon: 'warning'
        }).then((result) => {
          window.location.reload();
        });
      };
    
      React.useEffect(() => {
        if (showData) {
          // Reset fields before appending new ones
          remove(); // Remove all current rows in the form
          showData.forEach((row) => {
            append({ ...row }); // Append new rows
          });
        }
      }, [showData, append, remove, setValue]);

  return (
    <div>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div style={{ width: '100%', overflowX: 'auto', maxWidth: '90vw', }}>
                <TableContainer component={Paper} style={{ minWidth: 650, width: 'max-content', maxWidth: '100%', }}>
                    <Table 
                      sx={{ minWidth: 650 }}
                      aria-label="simple table"
                      >
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ minWidth: 120 }}>รหัสแบบเอกสาร</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>เลขที่ SO</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ชื่อลูกค้า</TableCell>
                                <TableCell align="center" sx={{ minWidth: 150 }}>ที่อยู่ลูกค้า</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>รหัสสินค้า</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>หมายเลขเครื่อง</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>วันที่ซื้อ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>รับประกัน</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>เงินดาวน์</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ค่างวด</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ราคาสุทธิ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>เดือนที่เกิดยอดขาย SO</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>เดือนที่ครบกำหนดชำระ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>วันที่ชำระเงินครั้งล่าสุด</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>จำนวนเงินที่ชำระครั้งล่าสุด</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>งวดที่เหลือ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>จำนวนเงินที่ชำระมาแล้วทั้งหมด</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ยอดหนี้คงค้าง</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ยอดเงินค่างวดที่ต้องชำระ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ยอดเงินที่ชำระค้างจ่าย</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>รวมเงินที่ต้องชำระ</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>SERVICECODE</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>เลขประจำตัวผู้เสีบภาษี</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>รหัสลูกหนี้</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>อีเมลล์</TableCell>
                                <TableCell align="center" sx={{ minWidth: 120 }}>ลบรายการ</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                          {fields.slice(page * rowsPerPage,Math.min(fields.length, (page + 1) * rowsPerPage),).map((row, index) => {
                            const globalIndex = page * rowsPerPage + index;
                            return (
                            <TableRow hover key={row.no || globalIndex}>
                                {/* รหัสแบบเอกสาร */}
                                {allowEdit ? (
                                    <TableCell align='center'>
                                        <TableCell align='center'>
                                            <TextField 
                                            variant="standard" 
                                            {...register(`rows.${globalIndex}.T`)}
                                            defaultValue={row.T}
                                            inputProps={{style: { textAlign: 'center' },}}
                                            />
                                        </TableCell>
                                    </TableCell>
                                ) : (
                                    <TableCell align='center'>
                                      {row.T || '-'} 
                                    </TableCell>
                                )}
                                {/* เลขที่ SO */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.SO`)}
                                        defaultValue={row.SO}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.SO}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.SO?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell>
                                        {row.SO || '-'}
                                    </TableCell>
                                )}
                                {/* ชื่อลูกค้า */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                      <TextareaAutosize
                                        minRows={1}
                                        defaultValue={row.custname}
                                        {...register(`rows.${globalIndex}.custname`)}
                                        aria-label={ariaLabel['aria-label']}
                                        style={{
                                          textAlign: 'left',
                                          width: '120px',
                                          resize: 'none',
                                          border: 'none',
                                          borderBottom: !!errors?.rows?.[globalIndex]?.custname
                                            ? '1px solid red'
                                            : '1px solid #AFAFAF',
                                          paddingBottom: '4px',
                                          outline: 'none',
                                          background: 'none',
                                        }}
                                      />
                                      {!!errors?.rows?.[globalIndex]?.custname && (
                                        <p
                                          style={{
                                            color: 'red',
                                            fontSize: '12px',
                                            marginTop: '4px',
                                          }}
                                        >
                                          {errors?.rows?.[globalIndex]?.custname?.message}
                                        </p>
                                      )}
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.custname || '-'}
                                    </TableCell>
                                )}
                                {/* ที่อยู่ลูกค้า */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                      <TextareaAutosize
                                        minRows={1}
                                        defaultValue={row.addr}
                                        {...register(`rows.${globalIndex}.addr`)}
                                        aria-label={ariaLabel['aria-label']}
                                        style={{
                                          textAlign: 'left',
                                          width: '120px',
                                          resize: 'none',
                                          border: 'none',
                                          borderBottom: !!errors?.rows?.[globalIndex]?.addr
                                            ? '1px solid red'
                                            : '1px solid #AFAFAF',
                                          paddingBottom: '4px',
                                          outline: 'none',
                                          background: 'none',
                                        }}
                                      />
                                      {!!errors?.rows?.[globalIndex]?.addr && (
                                        <p
                                          style={{
                                            color: 'red',
                                            fontSize: '12px',
                                            marginTop: '4px',
                                          }}
                                        >
                                          {errors?.rows?.[globalIndex]?.addr?.message}
                                        </p>
                                      )}
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.addr || '-'}
                                    </TableCell>
                                )}
                                
                                {/* รหัสสินค้า */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.productsetcode`)}
                                        defaultValue={row.productsetcode}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.productsetcode}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.productsetcode?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.productsetcode || '-'}
                                    </TableCell>
                                )}
                                {/* SerialNumber */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.serialnumber`)}
                                        defaultValue={row.serialnumber}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.serialnumber}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.serialnumber?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.serialnumber || '-'}
                                    </TableCell>
                                )}
                                {/* วันที่ซื้อ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.datesale`)}
                                        defaultValue={row.datesale}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.datesale}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.datesale?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                    {/* {dayjs(row.datesale).locale('th').format('DD MMMM YYYY') || '-'} */}
                                    {row.datesale || '-'}
                                    </TableCell>
                                )}
                                {/* รับประกัน */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                          variant="standard"
                                          {...register(`rows.${globalIndex}.termwarrantyMonth`)}
                                          defaultValue={row.termwarrantyMonth}
                                          inputProps={{
                                            style: { textAlign: 'center' },
                                          }}
                                          error={!!errors?.rows?.[globalIndex]?.termwarrantyMonth}
                                          helperText={
                                            errors?.rows?.[globalIndex]?.termwarrantyMonth?.message
                                          }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.termwarrantyMonth || '-'}
                                    </TableCell>
                                )}
                                {/* เงินดาวน์ */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                      <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.downamt`)}
                                        defaultValue={row.downamt}
                                        inputProps={{
                                          type: 'number',
                                          min: 1,
                                          style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.downamt}
                                        helperText={
                                          errors?.rows?.[globalIndex]?.downamt?.message
                                        }
                                      />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.downamt, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* ค่างวด */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                      <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.installation`)}
                                        defaultValue={row.installation}
                                        inputProps={{
                                          type: 'number',
                                          min: 1,
                                          style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.installation}
                                        helperText={
                                          errors?.rows?.[globalIndex]?.installation?.message
                                        }
                                      />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.installation, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* Totalmount */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                      <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.Totalmount`)}
                                        defaultValue={row.Totalmount}
                                        inputProps={{
                                          type: 'number',
                                          min: 1,
                                          style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.Totalmount}
                                        helperText={
                                          errors?.rows?.[globalIndex]?.Totalmount?.message
                                        }
                                      />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.Totalmount, 2) || '-'}
                                    </TableCell>
                                )}
                                 {/* เดือนที่เกิดยอดขาย SO */}
                                 {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.salemonth`)}
                                        defaultValue={row.salemonth}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.salemonth}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.salemonth?.message
                                        }
                                        />
                                    </TableCell>
                                 ) : (
                                    <TableCell align="center">
                                        {/* {dayjs(row.salemonth).locale('th').format('MMMM YYYY') || '-'} */}
                                        {row.salemonth || '-'}
                                    </TableCell>
                                 )}
                                {/* เดือนที่ครบกำหนดชำระ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.Duemonth`)}
                                        defaultValue={row.Duemonth}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.Duemonth}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.Duemonth?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {/* {dayjs(row.Duemonth).locale('th').format('MMMM YYYY') || '-'} */}
                                        {row.Duemonth || '-'}
                                    </TableCell>
                                )}
                                {/* วันที่ชำระเงินครั้งล่าสุด */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.lastreceiptdate`)}
                                        defaultValue={row.lastreceiptdate}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.lastreceiptdate}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.lastreceiptdate?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align='center'>
                                        {row.lastreceiptdate || '-'}
                                    </TableCell>
                                )}
                                {/* จำนวนเงินที่ชำระครั้งล่าสุด */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.lastpay`)}
                                        defaultValue={row.lastpay}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.lastpay}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.lastpay?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align='center'>
                                        {addCommas(row.lastpay, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* งวดที่เหลือ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.termbalance`)}
                                        defaultValue={row.termbalance}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.termbalance}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.termbalance?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {row.termbalance || '-'}
                                    </TableCell>
                                )}
                                 {/* จำนวนเงินที่ชำระมาแล้วทั้งหมด */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.allpaid`)}
                                        defaultValue={row.allpaid}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.allpaid}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.allpaid?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.allpaid, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* ยอดหนี้คงค้าง */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.Openbal`)}
                                        defaultValue={row.Openbal}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.Openbal}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.Openbal?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.Openbal, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* ยอดเงินค่างวดที่ต้องชำระ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.DueAmt`)}
                                        defaultValue={row.DueAmt}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.DueAmt}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.DueAmt?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.DueAmt, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* ยอดเงินที่ชำระค้างจ่าย */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.OverDue`)}
                                        defaultValue={row.OverDue}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.OverDue}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.OverDue?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.OverDue, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* รวมเงินที่ต้องชำระ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.PandingOD`)}
                                        defaultValue={row.PandingOD}
                                        inputProps={{
                                            type: 'number',
                                            min: 1,
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.PandingOD}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.PandingOD?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                        {addCommas(row.PandingOD, 2) || '-'}
                                    </TableCell>
                                )}
                                {/* SERVICECODE */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.SERVICECODE`)}
                                        defaultValue={row.SERVICECODE}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.SERVICECODE}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.SERVICECODE?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell>
                                        {row.SERVICECODE || '-'}
                                    </TableCell>
                                )}
                                {/* เลขประจำตัวผู้เสีบภาษี */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.IDNO`)}
                                        defaultValue={row.IDNO}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.IDNO}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.IDNO?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell>
                                        {row.IDNO || '-'}
                                    </TableCell>
                                )}
                                {/* รหัสลูกหนี้ */}
                                {allowEdit ? (
                                    <TableCell>
                                        <TextField
                                        variant="standard"
                                        {...register(`rows.${globalIndex}.ARCODE`)}
                                        defaultValue={row.ARCODE}
                                        inputProps={{
                                            style: { textAlign: 'center' },
                                        }}
                                        error={!!errors?.rows?.[globalIndex]?.ARCODE}
                                        helperText={
                                            errors?.rows?.[globalIndex]?.ARCODE?.message
                                        }
                                        />
                                    </TableCell>
                                ) : (
                                    <TableCell>
                                        {row.ARCODE || '-'}
                                    </TableCell>
                                )}
                                {/* อีเมลล์ */}
                                {allowEdit ? (
                                    <TableCell align="center">
                                        <TextareaAutosize
                                            minRows={1}
                                            defaultValue={row.Email}
                                            {...register(`rows.${globalIndex}.Email`)}
                                            aria-label={ariaLabel['aria-label']}
                                            style={{
                                            textAlign: 'left',
                                            width: '120px',
                                            resize: 'none',
                                            border: 'none',
                                            borderBottom: !!errors?.rows?.[globalIndex]?.Email
                                                ? '1px solid red'
                                                : '1px solid #AFAFAF',
                                            paddingBottom: '4px',
                                            outline: 'none',
                                            background: 'none',
                                            }}
                                        />
                                        {!!errors?.rows?.[globalIndex]?.Email && (
                                            <p
                                            style={{
                                                color: 'red',
                                                fontSize: '12px',
                                                marginTop: '4px',
                                            }}
                                            >
                                            {errors?.rows?.[globalIndex]?.Email?.message}
                                            </p>
                                        )}
                                    </TableCell>
                                ) : (
                                    <TableCell align="center">
                                    {row.Email || '-'}
                                    </TableCell>
                                )}
                                {/* Action */}
                                <TableCell align="center">
                                  <IconButton
                                    onClick={() => remove(globalIndex)}
                                    aria-label="delete"
                                    color="error"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </TableCell>

                            </TableRow>
                            );
                          })}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* </Paper> */}

                <TablePagination
                  sx={{
                    width: 'auto',
                    marginRight: '8px',
                    '& .MuiTypography-caption': { display: 'none' },
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  rowsPerPage={rowsPerPage}
                  page={page}
                  count={total}
                  labelRowsPerPage="Rows"
                  onPageChange={(event, newPage) => {
                    setPage(newPage);
                  }}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                />
                <div className="mt-7 flex justify-end">
                  <div className="mr-3">
                    {showData && (
                      <Button type="submit" variant="contained">
                        <div className="text-white">ยืนยันอัปโหลดข้อมูล</div>
                      </Button>
                    )}
                  </div>
                  <div>
                    <Button onClick={cancel} variant="outlined" color="error">
                      ยกเลิการอัปโหลด
                    </Button>
                  </div>
                </div>
            </div>
        </form>
    </div>
  )
}

export default TableUploadUtan